import { withCompInfo } from '@wix/editor-elements-integrations'
import { RefComponentCss, RefComponentDefinition } from './RefComponent'
import _ from 'lodash'

export const css = withCompInfo<RefComponentCss, RefComponentDefinition>()(
	['hasResponsiveLayout', 'compProps', 'experiments'],
	({ hasResponsiveLayout, compProps, experiments }, additionalData) => {
		const childHasResponsiveLayout = _.get(additionalData, ['childData', 'childHasResponsiveLayout'], false)
		const minHeight = compProps.minHeight
		const minHeightCss = minHeight ? { 'min-height': `${minHeight}px` } : {}

		// nested grids = bad performance
		const renderAsDisplayBlock = experiments['specs.thunderbolt.displayRefComponentsAsBlock']
		const useRefDisplayCssVar = experiments['specs.thunderbolt.useRefDisplayCssVar']
		const displayValue = renderAsDisplayBlock && !minHeight ? 'block' : 'grid'

		const displayCss = useRefDisplayCssVar
			? { display: displayValue }
			: { '--display': displayValue, display: 'var(--display)' }
		return !hasResponsiveLayout && childHasResponsiveLayout ? { ...minHeightCss, ...displayCss } : {}
	}
)
